<template>
    <div>{{ localizedDate }}</div>
</template>

<script>
    export default {
        name: "LocalizedDate",
        props: {
            date: {
                type: String,
                required: true
            }
        },
        computed: {
            localizedDate() {
                let date = new Date();

                try {
                    date = new Date(this.date);
                    return date.toLocaleDateString(this.$i18n.locale);
                } catch (e) {
                    return 'error localizing date';
                }
            }
        }
    }
</script>

<style scoped>

</style>